import { Card, CardHeader, Col } from 'reactstrap';
import styled from 'styled-components';

export const BaseCardChartContainer = styled(Card)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const BaseChartCardHeaderContainer = styled(CardHeader)`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 40rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 40.02rem) and (max-width: 64rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 64.02rem) and (max-width: 96rem) {
    justify-content: flex-start;
  }
`;

export const BaseColContainer = styled(Col)`
  align-self: center;
  width: 100%;
`;

export const BaseChartContainer = styled.div`
  width: 100%;
  max-height: 25rem;
  overflow-y: auto;
`;
